const DEFAULT_SIZE = 40;
const MAX_CONCURRENT = 3;

const srcByKey = new Map();
const listeners = new Set();
const queuedKeys = new Set();
const queue = [];
let active = 0;

function logoKey(imageUrl, size = DEFAULT_SIZE) {
	return `${imageUrl}?w=${size}&h=${size}`;
}

function notify() {
	listeners.forEach((listener) => {
		try {
			listener();
		} catch (error) {
			// Ignore subscriber errors so one bad listener cannot stall the cache.
		}
	});
}

function pump() {
	while (active < MAX_CONCURRENT && queue.length > 0) {
		const item = queue.shift();
		active += 1;
		loadOne(item).finally(() => {
			active -= 1;
			queuedKeys.delete(item.key);
			pump();
		});
	}
}

function loadOne({ key, src }) {
	return new Promise((resolve) => {
		const img = new Image();
		img.decoding = 'async';
		img.onload = () => {
			srcByKey.set(key, src);
			notify();
			resolve();
		};
		img.onerror = () => {
			srcByKey.set(key, '');
			notify();
			resolve();
		};
		img.src = src;
	});
}

export function getCachedTeamLogoSrc(imageUrl, size = DEFAULT_SIZE) {
	if (!imageUrl) return null;
	const key = logoKey(imageUrl, size);
	if (!srcByKey.has(key)) return null;
	const cached = srcByKey.get(key);
	return cached || null;
}

export function subscribeTeamLogoCache(listener) {
	listeners.add(listener);
	return () => listeners.delete(listener);
}

export function prefetchTeamLogos(imageUrls, size = DEFAULT_SIZE) {
	const uniqueUrls = Array.from(new Set((imageUrls || []).filter(Boolean)));

	uniqueUrls.forEach((imageUrl) => {
		const key = logoKey(imageUrl, size);
		if (srcByKey.has(key) || queuedKeys.has(key)) return;

		queuedKeys.add(key);
		queue.push({ key, src: key });
	});

	pump();
}

export const TEAM_LOGO_CACHE_SIZE = DEFAULT_SIZE;
